<div class="profile-container">
  <div class="">
      <div class="profile-content">
        <!-- <button class="add-task" data-toggle="modal" data-target="#exampleModal">Add</button> -->

          <div class="personal-details">
            <div class="header-block">
              <div class="header-title">
                  <p>Customer Location</p>
              </div>
              <div class="add-block">
                <div class="search">
                  <form autocomplete="off" >
                      <input type="text" placeholder="search user" [ngModelOptions]="{standalone: true}" [(ngModel)]="search">
                  </form>
                  <i class="bi bi-search" ></i>
                </div>
              </div>
            </div>
              <div class="row">
                <div class="col-md-9 col-lg-9">
                  <div class="map-container">
                    <div class="map-frame">
                      <div id="map">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-lg-3" style="padding-left: 0;">
                  <div class="customerList">
                    <p (click)="onChoseLocation()" >All</p>
                    <p *ngFor="let list of customerInfo | filter:search;let i = index " (click)="singleLocation(list.id)">{{list.name}}</p>
                  </div>
                </div>
              </div>
          
          </div>

      </div>
  </div>
</div>